// 移植自 crm/src/DrawerMenu.jsx（手機抽屜選單）。選單項目與 SideMenu 共用 ./menuItems.js，
// 差異只在抽屜特有的部分：logo 列、點擊項目後關閉抽屜、沒有收合狀態。
import { useLocation } from 'react-router'
import { access } from '@/lib/auth'
import { t } from '@/i18n'
import { AppLink } from '@/components/ui/AppLink'
import Logo from '@/assets/logo-choice.svg'
import { MAIN_MENU, SYSTEM_MENU, BADGE_STYLE, isMenuActive } from './menuItems'
import { useMenuBadges } from './useMenuBadges'

function NavItem({ item, active, badge, onNavigate }) {
  const Icon = item.icon
  const badgeStyle = badge ? BADGE_STYLE[item.badge] : null
  return (
    <li className="w-full">
      <AppLink
        href={item.href}
        onClick={onNavigate}
        className={`relative flex w-full items-center gap-2 rounded-brand-large p-2.5 text-base font-medium leading-5 transition-colors ${active ? 'bg-brand-primary text-white' : 'text-brand-black-700 hover:bg-brand-primary-hover hover:text-white'}`}
      >
        <span className="flex size-5.5 shrink-0 items-center justify-center">
          <Icon className="size-5.5" />
        </span>
        <span>{t('app', item.label)}</span>
        {badgeStyle && <span aria-label="status" className={`ml-auto shrink-0 rounded-full ${badgeStyle.size} ${badgeStyle.className}`} />}
      </AppLink>
    </li>
  )
}

// onNavigate：點了選單項目後要做的事（關閉抽屜）
export function DrawerMenu({ onNavigate }) {
  const { pathname } = useLocation()
  const badges = useMenuBadges()

  const renderItems = (items) =>
    items
      .filter((item) => !item.perms || access(...item.perms))
      .map((item) => (
        <NavItem key={item.href} item={item} active={isMenuActive(pathname, item)} badge={item.badge ? badges[item.badge] : false} onNavigate={onNavigate} />
      ))

  return (
    <div className="task-drawer-bg text-brand-base-content min-h-full w-72">
      {/* logo 列：與桌面頂欄一致只放 logo 圖 */}
      <div className="h-15 flex items-center justify-center">
        <h1 className="text-xl flex items-center gap-2">
          <img src={Logo} height={20} />
        </h1>
      </div>
      <div className="px-3 py-4">
        <span className="px-2.5 text-xs font-medium leading-[18px] text-brand-black-500">{t('app', 'System Directory')}</span>
        <ul className="mt-1 flex flex-col gap-1">{renderItems(MAIN_MENU)}</ul>

        <h2 className="mb-1 mt-4 px-2.5 text-xs font-medium leading-[18px] text-brand-black-500">{t('app', 'System')}</h2>
        <ul className="flex flex-col gap-1">{renderItems(SYSTEM_MENU)}</ul>
      </div>
    </div>
  )
}
